import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assests/LOGO_KRISTELLAR_WHITE.png";

const Navbar = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const sidebarRef = useRef(null);
  const buttonRef = useRef(null);
  const location = useLocation();

  function toggleSidebar() {
    setIsSidebarActive(!isSidebarActive);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsSidebarActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="flex items-center justify-between w-full bg-navBlue text-white shadow-lg px-4 sm:px-36 md:px-16 lg:px-24 xl:px-32 2xl:px-36 3xl:px-64 4xl:px-72 5xl:px-80 6xl:px-96 7xl:px-[30rem] h-24">
      {/* Logo Container */}
      <div className="flex items-center">
        <Link to="/">
          <img
            src={logo}
            alt="Consulting Logo"
            className="h-32 min-[910px]:h-32 2xl:h-32 4xl:h-40 6xl:h-44 object-contain"
          />
        </Link>
      </div>

      {/* Navigation Links */}
      <div className="hidden min-[910px]:flex flex-grow justify-center max-w-none sm:max-w-6xl xl:max-w-5xl 2xl:max-w-6xl 3xl:max-w-7xl 4xl:max-w-[88rem] 5xl:max-w-[96rem] 6xl:max-w-[104rem] 7xl:max-w-[120rem]">
        <ul className="flex gap-6 lg:gap-8 xl:gap-8 2xl:gap-8 3xl:gap-12 4xl:gap-16 5xl:gap-20 6xl:gap-24 7xl:gap-28 font-semibold">
          {[
            { name: "HOME", path: "/" },
            { name: "PRODUCTS", path: "/products" },
            { name: "PROJECTS", path: "/project" },
            { name: "BLOG", path: "/blog1" },
            { name: "PUBLICATION", path: "/publication" },
            { name: "CONTACT", path: "/contact" },
            { name: "CAREERS", path: "/careers" },
            {/* { name: "TEAMS", path: "/teams" }, */}
          ].map((item) => (
            <li
              key={item.name}
              className={`font-nova-square hover:text-yellow-400 whitespace-nowrap font-thin
                text-sm      /* Default - Mobile */
                md:text-base /* 768px */
                lg:text-lg   /* 1024px */
                xl:text-lg   /* 1280px */
                2xl:text-lg /* 1536px */
                3xl:text-xl /* 1920px */
                4xl:text-2xl /* 2560px */
                5xl:text-3xl /* 3072px */
                6xl:text-4xl /* 3840px */
                7xl:text-5xl /* 5120px */
                transition-all duration-300
                ${isActive(item.path) ? "text-yellow-400" : ""}`}
            >
              <Link to={item.path}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="min-[910px]:hidden text-2xl focus:outline-none ml-auto"
        onClick={toggleSidebar}
        ref={buttonRef}
      >
        ☰
      </button>

      {/* Mobile Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-indigo-900 shadow-md transform ${
          isSidebarActive ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out min-[910px]:hidden z-50`}
        ref={sidebarRef}
      >
        <ul className="flex flex-col items-start p-6 space-y-4 font-semibold text-white">
          {[
            { name: "HOME", path: "/" },
            { name: "PRODUCTS", path: "/products" },
            { name: "PROJECTS", path: "/project" },
            { name: "BLOG", path: "/blog1" },
            { name: "PUBLICATION", path: "/publication" },
            { name: "CONTACT", path: "/contact" },
            { name: "CAREERS", path: "/careers" },
            {/* { name: "TEAMS", path: "/teams" }, */}
          ].map((item) => (
            <li
              key={item.name}
              className={`font-nova-square hover:text-yellow-400 text-base ${
                isActive(item.path) ? "text-yellow-400" : ""
              }`}
            >
              <Link to={item.path}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;